import { z } from 'zod';

export const ListFolderRequestSchema = z
  .object({
    LaboratoryId: z.string(),
    S3Bucket: z.string().optional(),
    S3Prefix: z.string().refine((s) => s.endsWith('/'), {
      message: 'S3Prefix must end with "/"',
    }),
    ContinuationToken: z.string().optional(),
    PageSize: z.number().int().min(1).max(1000).optional(),
  })
  .strict();

export const ListFolderResponseSchema = z
  .object({
    Folders: z.array(z.object({ Prefix: z.string(), Name: z.string() })),
    Files: z.array(
      z.object({
        Key: z.string(),
        Name: z.string(),
        Size: z.number(),
        LastModified: z.string(),
        ETag: z.string(),
        StorageClass: z.string().optional(),
      }),
    ),
    IsTruncated: z.boolean(),
    NextContinuationToken: z.string().optional(),
  })
  .strict();
